/**
 * Show/hide elements based on a checkbox's checked
 * state. Mirrors `radio-dependent` for checkboxes.
 *
 * @example
 * ```html
 * <div data-controller="checkbox-dependent">
 *   <input type="checkbox"
 *          data-checkbox-dependent-target="trigger"
 *          data-action="change->checkbox-dependent#toggle"
 *          checked>
 *   <div data-checkbox-dependent-target="dependent"
 *        data-show-when="checked">
 *     Visible only when the checkbox is checked
 *   </div>
 *   <div data-checkbox-dependent-target="dependent"
 *        data-show-when="unchecked">
 *     Visible only when the checkbox is unchecked
 *   </div>
 * </div>
 * ```
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "dependent"];

  connect() {
    if (this.hasTriggerTarget) {
      this.updateDependents(this.triggerTarget.checked);
    }
  }

  toggle(event) {
    this.updateDependents(event.target.checked);
  }

  updateDependents(checked) {
    const state = checked ? "checked" : "unchecked";
    this.dependentTargets.forEach((dependent) => {
      const showWhen = dependent.dataset.showWhen;
      if (!showWhen) return;
      const shouldShow = showWhen
        .split(",")
        .map((v) => v.trim())
        .includes(state);
      dependent.classList.toggle("hidden", !shouldShow);
    });
  }
}
